import { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import { useDimensions } from '../scene/useDimensions'

const scale = [0.01, 0.01, 0.01]
const offsetZ = 0.0
const offsetBorder = 0.1

export const TwinBoxes = () => {
  const group: any = useRef()

  const { length, width, thickness, fullThickness } = useDimensions()

  const shortSide = Math.min(length, width)
  const rotation = [Math.PI / 2, length < width ? Math.PI / 2 : 0, 0]

  let positionPlus = [
    offsetBorder,
    offsetBorder,
    fullThickness - thickness + offsetZ - 0.005,
  ]
  let positionMinus = [
    offsetBorder,
    shortSide - offsetBorder,
    fullThickness - thickness + offsetZ - 0.005,
  ]

  if (length > width) {
    positionPlus = [positionPlus[1], length - positionPlus[0], positionPlus[2]]
    positionMinus = [
      positionMinus[1],
      length - positionMinus[0],
      positionMinus[2],
    ]
  }

  const { nodes } = useGLTF('models/TwinBox_plus_minus.glb') as GLTF & any

  return (
    <group ref={group}>
      <primitive
        object={nodes.TwinBox_plus}
        scale={scale}
        rotation={rotation}
        position={positionPlus}
      />

      <primitive
        object={nodes.TwinBox_minus}
        scale={scale}
        rotation={rotation}
        position={positionMinus}
      />
    </group>
  )
}
